import {
  STORAGE_BOX_SIDEBAR_WIDTH_DEFAULT,
  STORAGE_BOX_SIDEBAR_WIDTH_MAX,
  STORAGE_BOX_SIDEBAR_WIDTH_MIN,
  STORAGE_BOX_SIDEBAR_WIDTH_STORAGE_KEY,
} from '../constants';

export function clampStorageBoxSidebarWidth(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return STORAGE_BOX_SIDEBAR_WIDTH_DEFAULT;
  return Math.min(STORAGE_BOX_SIDEBAR_WIDTH_MAX, Math.max(STORAGE_BOX_SIDEBAR_WIDTH_MIN, Math.round(n)));
}

export function readStoredSidebarWidth() {
  try {
    const raw = localStorage.getItem(STORAGE_BOX_SIDEBAR_WIDTH_STORAGE_KEY);
    if (raw == null || raw === '') return null;
    return clampStorageBoxSidebarWidth(raw);
  } catch {
    return null;
  }
}

export function writeStoredSidebarWidth(widthPx) {
  try {
    localStorage.setItem(STORAGE_BOX_SIDEBAR_WIDTH_STORAGE_KEY, String(clampStorageBoxSidebarWidth(widthPx)));
  } catch {
    /* ignore */
  }
}
